<template>
  <el-dialog title="包材费用" :visible.sync="dialogTableVisible" width="25%">
    <el-row>
      <el-col :span="24" class="line-height">国际运单：国际189415165</el-col>
      <el-col :span="24" class="line-height">订单：189415165</el-col>
      <el-col :span="12" class="line-height">包材：木架</el-col>
      <el-col :span="12" class="line-height">申报金额：CNY</el-col>
      <el-col :span="24" class="line-height">说明:</el-col>
      <el-col :span="24">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 4}"
          placeholder="请输入内容"
          v-model="Explain"
        ></el-input>
      </el-col>
    </el-row>
    <div style="margin-top: 10px;">
      <el-upload
        action="https://jsonplaceholder.typicode.com/posts/"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove"
      >
        <i class="el-icon-plus" style="color: #0724ef;"></i>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible" append-to-body>
        <img width="100%" :src="dialogImageUrl" alt />
      </el-dialog>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogTableVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogTableVisible = false">提 交</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "Packingmaterials",
  data() {
    return {
      dialogTableVisible: false,
      Declaredamount: "",
      Explain: "",
      dialogImageUrl: "",
      dialogVisible: false
    };
  },
  mounted() {},
  created() {},
  methods: {
    init() {
      this.dialogTableVisible = true;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ {
  .el-dialog__body {
    padding: 13px 20px;
  }
}
.line-height {
  line-height: 35px;
}
</style>